// extracted by mini-css-extract-plugin
export default {"textBox":"RichBox_textBox__fJabk"};